export enum SchoolClassVisibilities {
    PUBLIC = "PUBLIC",
    PRIVATE = "PRIVATE",
}
